import { render } from "./OriginManage.vue?vue&type=template&id=5234984a&scoped=true"
import script from "./OriginManage.vue?vue&type=script&lang=js"
export * from "./OriginManage.vue?vue&type=script&lang=js"

import "./OriginManage.vue?vue&type=style&index=0&id=5234984a&scoped=true&lang=css"
import "./OriginManage.vue?vue&type=style&index=1&id=5234984a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5234984a"],['__file',"src/views/Origin/OriginManage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5234984a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5234984a', __exports__)) {
    api.reload('5234984a', __exports__)
  }
  
  module.hot.accept("./OriginManage.vue?vue&type=template&id=5234984a&scoped=true", () => {
    api.rerender('5234984a', render)
  })

}


export default __exports__